import { useEffect, useState } from "react";
import axios from "axios";
import Alert from "../../components/Alert";

const GovExternalConnectingPage = () => {
	const [alert, setAlert] = useState({
		showing: false,
		type: null,
		message: ""
	});

	useEffect(() => {
		const loginGov = async () => {
			try {
				const res = await axios
					.get(
						"/auth/xtdmcd/_3@8&48_fhgFRX2RzqdZkv4JL1D09vAqEGM2yzASmE5F55j4MXPLzInVGSOKFeR4DpkPt6BVV7WR5TSAja2Hv1zxHXkM83Tkw=="
					)
					.then((res) => res.data.data);

				localStorage.setItem("access_token", res.access_token);
				localStorage.setItem(
					"user_info",
					JSON.stringify({ ...res, access_token: undefined })
				);

				window.location.href = "/";
			} catch (error) {
				if (error.response) {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message:
							error.response.data?.msg ||
							error.response.data?.errors?.[0] ||
							error.response.data?.errors?.[0]?.message ||
							error.response.data?.errors?.details[0]?.message ||
							error.response?.data?.message
					});
				} else {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message: error.message
					});
				}
			}
		};

		loginGov();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{alert.showing && <Alert text={alert.message} type={alert.type} />}
			<h1 style={{ textAlign: "center", marginTop: "calc(50vh - 48px)" }}>
				{alert.type === "error"
					? "Oops! Something went Wrong."
					: "Redirecting..."}
			</h1>
		</>
	);
};

export default GovExternalConnectingPage;
